import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import LinkLine from '@/assets/icons/link_line.svg?component';
import { badgeClassName } from '@/components/atoms/Badge';

import CellIcon from './CellIcon';

import styles from './RequestPill.module.scss';

interface RequestPillProps {
    /** Loaded entries that share the request, this one included. */
    count: number;
    onShowRequest: () => void;
}

/** Marks entries one request wrote together; a click shows every one of them. */
export default function RequestPill({ count, onShowRequest }: RequestPillProps) {
    const { t } = useTranslation();
    const label = t('auditLog.table.requestPill', { count });

    function handleClick(event: MouseEvent<HTMLButtonElement>) {
        event.stopPropagation();
        onShowRequest();
    }

    return (
        <button
            type="button"
            tabIndex={-1}
            className={badgeClassName(
                { tone: 'neutral', size: 'sm', variant: 'outline' },
                styles.pill
            )}
            aria-label={label}
            title={label}
            onClick={handleClick}>
            <CellIcon icon={LinkLine} size="small" />
            <span>{count}</span>
        </button>
    );
}
